// Bilingual translation dictionary (id = default, en)
export const translations = {
  id: {
    common: {
      appName: "Fat Loss Program",
      appTagline: "Transformasi tubuh berbasis disiplin",
      backToHome: "Beranda",
      loading: "Memuat…",
      save: "Simpan",
      cancel: "Batal",
      submit: "Kirim",
      back: "Kembali",
      email: "Email",
      password: "Kata Sandi",
      confirmPassword: "Konfirmasi Kata Sandi",
      fullName: "Nama Lengkap",
      whatsapp: "Nomor WhatsApp (opsional)",
      language: "Bahasa",
      logout: "Keluar",
      status: "Status",
      edit: "Ubah",
      delete: "Hapus",
      deleted: "Berhasil dihapus",
      saved: "Tersimpan",
      yes: "Ya",
      no: "Tidak",
      selectDate: "Pilih tanggal",
    },
    upload: {
      choose: "Pilih foto",
      camera: "📷 Ambil Foto",
      gallery: "🖼️ Pilih dari Galeri / File",
      uploading: "Mengunggah…",
      optimizing: "Mengoptimalkan foto…",
      done: "Foto siap",
      tooLarge: "Ukuran file maksimal 10 MB",
      tooLargeToProcess: "Foto terlalu besar untuk diproses. Silakan pilih foto lain.",
      processError: "Foto belum dapat diproses. Silakan coba pilih foto lain.",
      mimeError: "Format tidak didukung. Pilih foto JPG, PNG, atau WEBP.",
      hint: "JPG / PNG / WEBP / HEIC · maks 10 MB",
      hintCompress: "Foto otomatis dioptimalkan sebelum diunggah · JPG / PNG / WEBP",
    },
    storage: {
      title: "Penghematan Storage",
      subtitle: "Ringkasan kompresi foto otomatis",
      totalPhotos: "Total foto",
      stored: "Ukuran tersimpan",
      original: "Ukuran asli",
      saved: "Total dihemat",
      avgRatio: "Rata-rata kompresi",
      optimized: "foto dioptimalkan",
      byKind: "Rincian per jenis",
      kind: "Jenis",
      cdnTitle: "Pengiriman Gambar (Cloudflare R2)",
      cdnDesc: "Migrasikan foto ke R2 & buat thumbnail untuk foto lama. Aman diulang.",
      cdnEnabled: "R2 aktif",
      cdnDisabled: "R2 belum dikonfigurasi",
      backfillRun: "Jalankan Migrasi + Backfill",
      backfillRunning: "Migrasi berjalan…",
      backfillMigrated: "Termigrasi",
      backfillThumbs: "Thumbnail dibuat",
      backfillErrors: "Error",
      backfillDone: "Selesai",
      backfillStarted: "Migrasi dimulai di latar belakang.",
    },
    streak: {
      days: "hari berturut-turut",
      longest: "Rekor terpanjang",
      rule: "dihitung bila Education & Jurnal Makan selesai di hari yang sama",
      education: "Materi hari ini",
      journal: "Jurnal makan",
      boardTitle: "Papan Streak Batch",
      boardEmpty: "Belum ada member aktif di batch ini.",
      coach: "Coach",
      noCoach: "Belum ada coach",
      daysDone: "hari materi selesai",
      record: "Rekor",
    },
    crm: {
      chatWhatsapp: "Chat WhatsApp",
      openWhatsapp: "Buka WhatsApp",
      noWhatsapp: "Nomor WhatsApp belum terdaftar",
      lastReminded: "Terakhir diingatkan",
      justNow: "baru saja",
      minAgo: "{n} menit lalu",
      hourAgo: "{n} jam lalu",
      dayAgo: "{n} hari lalu",
      dialogTitle: "Kirim pengingat",
      messageLabel: "Pesan (bisa diedit)",
      noteLabel: "Catatan untuk member",
      notePlaceholder: "Catatan singkat, mis. sudah dihubungi, janji isi malam",
      saveNote: "Simpan",
      noteSaved: "Catatan tersimpan",
      defaultName: "Member",
      tplEducation: "Halo {name} 👋 Jangan lupa kerjakan materi edukasi harianmu hari ini ya. Semangat! 💪",
      tplFoodJournal: "Halo {name} 👋 Hari ini kamu belum mencatat jurnal makan. Yuk laporkan makananmu supaya progresnya terpantau 🍽️",
      save: "Simpan",
      templatesLabel: "Template tersimpan",
      saveAsTemplate: "Simpan sebagai template",
      templateTitlePlaceholder: "Judul template",
      templateSaved: "Template tersimpan",
      templateDeleted: "Template dihapus",
      noTemplates: "Belum ada template",
      nameHint: "{name} akan otomatis diganti nama member",
      history: "Riwayat pengingat",
      historyEmpty: "Belum pernah diingatkan",
      ctxEducation: "Edukasi",
      ctxFood: "Jurnal Makan",
      behindOnly: "Hanya yang tertinggal",
      missingOnly: "Hanya yang belum lapor",
    },
    food: {
      eyebrow: "Nutrisi",
      title: "Jurnal Makan",
      subtitleMember: "Catat setiap waktu makan dengan foto — Coach akan memberi masukan",
      subtitleCoach: "Pantau dan komentari jurnal makan member",
      member: "Member",
      filterDate: "Tanggal",
      empty: "Belum ada entri jurnal makan.",
      mealType: "Waktu Makan",
      meal_SARAPAN: "Sarapan",
      meal_MAKAN_SIANG: "Makan Siang",
      meal_MAKAN_MALAM: "Makan Malam",
      meal_SNACK: "Snack",
      photo: "Foto makanan",
      photoRequired: "Unggah foto makanan dulu",
      note: "Catatan (opsional)",
      save: "Simpan Entri",
      saving: "Menyimpan…",
      saved: "Entri jurnal tersimpan",
      confirmDelete: "Hapus entri ini?",
      comment: "Kirim",
      commentPlaceholder: "Tulis komentar…",
      adminReadOnly: "Administrator hanya dapat melihat, tidak berkomentar.",
      audit: "Audit AI",
      reaudit: "Audit Ulang",
      auditDone: "Audit AI selesai",
      auditHint: "Entri makan siang otomatis dianalisis AI.",
      aiVerdict: "Penilaian AI",
      verdict_BAIK: "Baik",
      verdict_CUKUP: "Cukup",
      verdict_PERLU_PERBAIKAN: "Perlu Perbaikan",
      tabMine: "Jurnal Saya",
      tabWall: "Wall Makanan",
      tabCompliance: "Kepatuhan Hari Ini",
      tabMember: "Jurnal Member",
      logged: "Sudah mengisi",
      notLogged: "Belum mengisi",
      statusLogged: "SUDAH",
      statusMissing: "BELUM",
      notLoggedToday: "Belum ada entri makan hari ini",
      entriesToday: "entri",
      noMembers: "Belum ada member aktif.",
      openJournal: "Buka Jurnal",
      dailySummary: "Ringkasan Gizi Harian",
      makeSummary: "Buat Ringkasan Hari Ini",
      summarizing: "Meringkas…",
      summaryDone: "Ringkasan gizi dibuat",
      noSummary: "Belum ada ringkasan. Catat makan Anda lalu buat ringkasan, atau tunggu ringkasan otomatis pukul 20.00 WIB.",
      react: "Beri apresiasi",
      locked: "Jurnal Makan akan tersedia setelah akun Anda diaktifkan.",
      tabFeed: "Wall Batch",
      newPost: "+ Buat Jurnal",
      postFood: "Jurnal Makan",
      postEducation: "Posting Edukasi",
      caption: "Caption",
      captionPlaceholder: "Tulis caption, edukasi, menu makan, atau informasi untuk komunitas...",
      readMore: "Selengkapnya",
      showLess: "Ringkas",
      uploadedAt: "Diunggah",
      capturedAt: "Foto diambil",
      captureUnknown: "Waktu pengambilan tidak tersedia",
      location: "Lokasi",
      shareLocation: "Sertakan lokasi saya",
      locationDenied: "Lokasi tidak dibagikan",
      reply: "Balas",
      replyPlaceholder: "Tulis balasan…",
      sending: "mengirim…",
      hide: "Sembunyikan",
      unhide: "Tampilkan",
      hidden: "DISEMBUNYIKAN",
      filterRole: "Role",
      filterType: "Jenis",
      filterBatch: "Batch",
      filterOwner: "Pemilik",
      all: "Semua",
      leaderboard: "Aktivitas Jurnal Makan",
      pointsPerBatchNote: "Poin dihitung berdasarkan batch yang sedang aktif. Poin dari batch sebelumnya tidak diakumulasikan.",
      posts: "posting",
      points: "poin",
      aiLimit: "Batas 1 AI Food Review per hari sudah terpakai.",
      aiCached: "hasil tersimpan",
    },
    branding: {
      eyebrow: "Tampilan",
      title: "Branding",
      subtitle: "Atur logo, nama, warna, teks halaman depan, dan kontak",
      identity: "Identitas",
      appName: "Nama Aplikasi",
      tagline: "Tagline",
      accent: "Warna Aksen",
      logo: "Logo",
      removeLogo: "Hapus Logo",
      hero: "Halaman Depan — Hero",
      heroEyebrow: "Label Kecil",
      heroTitle: "Judul Utama",
      heroBody: "Deskripsi",
      steps: "Langkah Alur",
      stepTitle: "Judul Langkah",
      stepBody: "Deskripsi Langkah",
      faq: "FAQ",
      question: "Pertanyaan",
      answer: "Jawaban",
      contact: "Kontak & Sosial Media",
      whatsapp: "WhatsApp",
      email: "Email",
      addItem: "Tambah",
      save: "Simpan Perubahan",
      saved: "Branding tersimpan",
      fallbackHint: "Kosongkan untuk memakai teks bawaan aplikasi.",
    },
    paymentSettings: {
      title: "Pengaturan Pembayaran",
      subtitle: "Kelola rekening tujuan Support Service Fee",
      sectionTitle: "Rekening Tujuan Pembayaran",
      add: "+ Tambah Rekening",
      empty: "Belum ada rekening. Tambahkan rekening tujuan pembayaran.",
      bankName: "Nama Bank",
      accountNumber: "Nomor Rekening",
      holderName: "Nama Pemilik Rekening",
      displayLabel: "Label Tampilan",
      status: "Status",
      active: "Aktif",
      inactive: "Nonaktif",
      default: "Rekening Utama",
      setDefault: "Jadikan Utama",
      activate: "Aktifkan",
      deactivate: "Nonaktifkan",
      save: "Simpan Perubahan",
      saved: "Perubahan tersimpan",
      deleted: "Rekening dihapus",
      confirmDefault: "Ganti rekening utama tujuan pembayaran? Instruksi pembayaran berikutnya akan memakai rekening ini.",
      confirmDelete: "Hapus rekening ini? Rekening tidak dapat dipakai untuk pembayaran baru.",
      notSet: "Rekening tujuan belum diatur. Hubungi Administrator.",
    },
    nav: { programs: "Program", journey: "Perjalanan Saya", payments: "Pembayaran", coachDev: "Kandidat Coach", education: "Edukasi", qualification: "Kualifikasi Coach", users: "Pengguna", paymentSettings: "Pengaturan Pembayaran", foodJournal: "Jurnal Makan", branding: "Branding", measurements: "Data Timbang", recognition: "Recognition Wall", moderation: "Moderasi Jurnal", groupProgram: "Program", groupLearning: "Pembelajaran", groupCommunity: "Komunitas", groupSettings: "Pengaturan" },
    measure: {
      eyebrow: "Progres Fisik",
      title: "Data Timbang",
      subtitleMember: "Empat titik ukur: Hari 1, Hari 6, Hari 11, dan Final Hari 15",
      subtitleCoach: "Catat berat, body fat, dan foto progres member Anda",
      weight: "Berat (kg)",
      bodyFat: "Body fat (%)",
      baseline: "Data Awal",
      final: "Hasil Final",
      deltaFromStart: "Selisih dari awal",
      deleteData: "Hapus Data",
      dataDeleted: "Data timbang dihapus",
      confirmDelete: "Hapus data timbang checkpoint ini? Foto terkait ikut dihapus dan tidak bisa dibatalkan.",
      sortBy: "Urutkan",
      sort_behind: "Paling tertinggal",
      sort_filled: "Paling lengkap",
      sort_name: "Nama",
      photo_before: "Foto Before (Hari 1)",
      photo_after: "Foto After (Final Hari 15)",
      photoNumbersOnly: "Checkpoint ini hanya mencatat angka (tanpa foto).",
      batch: "Batch",
      member: "Member",
      pickMember: "Pilih member",
      due: "Jadwal",
      noSchedule: "Jadwal belum tersedia",
      status_FILLED: "Tercatat",
      status_DUE_TODAY: "Timbang hari ini",
      status_OVERDUE: "Terlewat",
      status_UPCOMING: "Akan datang",
      status_PENDING: "Belum diisi",
      weightBefore: "Berat sebelum (kg)",
      weightAfter: "Berat sesudah (kg)",
      fatBefore: "Body fat sebelum (%)",
      fatAfter: "Body fat sesudah (%)",
      photoBefore: "Foto sebelum",
      photoAfter: "Foto sesudah",
      photoFinalOnly: "Foto sebelum & sesudah hanya diunggah pada Final Hari 15.",
      deletePhoto: "Hapus foto",
      photoDeleted: "Foto dihapus",
      galleryConsent: "Tampilkan transformasi ini di galeri publik landing page (nama disingkat, mis. \"Andrie S.\")",
      galleryOn: "Ditampilkan di galeri publik",
      galleryOff: "Dihapus dari galeri publik",
      note: "Catatan coach",
      record: "Catat Data",
      edit: "Ubah Data",
      saved: "Data timbang tersimpan",
      trend: "Grafik Tren",
      trendWeight: "Berat (kg)",
      trendFat: "Body fat (%)",
      noData: "Belum ada data timbang.",
      readOnly: "Hanya Coach yang dapat mengisi Data Timbang.",
      delta: "Selisih",
      filled: "titik terisi",
      reminderHint: "Pengingat otomatis dikirim ke member dan coach pada pagi hari-H (07:00 WIB).",
    },
    recog: {
      eyebrow: "Apresiasi",
      title: "Recognition Wall",
      subtitle: "Top 10 hasil Final Hari 15 per batch + aktivitas mingguan",
      week: "Pekan",
      champion: "Member Terbaik Pekan Ini",
      pinned: "Sematan Coach",
      pin: "Sematkan",
      unpin: "Lepas sematan",
      pinNote: "Alasan sematan (opsional)",
      pinned_ok: "Member disematkan",
      unpinned_ok: "Sematan dilepas",
      score: "Skor",
      points: "Poin jurnal",
      streak: "Streak",
      compliance: "Kepatuhan",
      weightLost: "Turun berat",
      fatLost: "Turun body fat",
      ranking: "Peringkat Pekan Ini",
      finals: "Hasil Final Hari 15",
      before: "Sebelum",
      after: "Sesudah",
      downloadCard: "Unduh Kartu Transformasi",
      empty: "Belum ada aktivitas pekan ini.",
      tab_top: "Top 10 Hasil Final",
      tab_weekly: "Aktivitas Mingguan",
      board_member_weight: "Top 10 Member — Turun Berat Terbanyak",
      board_member_fat: "Top 10 Member — Turun Body Fat % Terbanyak",
      board_coach_weight: "Top 10 Coach — Turun Berat Terbanyak",
      board_coach_fat: "Top 10 Coach — Turun Body Fat % Terbanyak",
      displayMode: "Tampilkan di Recognition Wall",
      mode_BOTH: "Coach & Member berdampingan",
      mode_MEMBER_ONLY: "Member saja",
      mode_COACH_ONLY: "Coach saja",
      modeSaved: "Pengaturan tampilan disimpan",
      topSource: "Diambil dari Data Timbang Final Hari 15 batch ini — maksimal {n} nama per kategori.",
      topHint: "Hanya peserta dengan penurunan (angka positif) yang masuk papan ini.",
      noFinals: "Belum ada data Final Hari 15 di batch ini.",
      inGallery: "Di galeri publik",
      formula: "Skor = poin jurnal + streak×5 + kepatuhan×20 + kg turun×10 + %body fat turun×5",
    },
    del: {
      manage: "Kelola/Hapus",
      batchTitle: "Hapus Batch & Pesertanya",
      programTitle: "Hapus Program, Batch & Pesertanya",
      warning: "Tindakan ini permanen. Akun pengguna TIDAK dihapus — hanya keikutsertaan dan datanya di batch ini.",
      typeToConfirm: 'Ketik "{word}" untuk konfirmasi',
      clearBatch: "Kosongkan batch",
      forceDelete: "Hapus permanen",
      cleared: "{n} peserta dihapus, batch tetap ada",
      deleted: "Berhasil dihapus",
      confirmEnrollment: "Hapus peserta {name} dari batch ini beserta pembayaran, data timbang, dan postingan jurnalnya?",
      enrollmentDeleted: "Peserta dihapus dari batch",
      c_enrollments: "Peserta",
      c_active_enrollments: "Peserta aktif",
      c_payments: "Pembayaran",
      c_measurements: "Data timbang",
      c_journal_posts: "Postingan jurnal",
      c_comments: "Komentar",
      c_reactions: "Reaksi",
      c_journal_points: "Poin jurnal",
      c_recognition_pins: "Sematan",
      c_batches: "Batch",
    },
    mod: {
      eyebrow: "Moderasi",
      title: "Moderasi Jurnal",
      subtitle: "Filter jurnal per batch, rentang tanggal, dan postingan tersembunyi",
      batch: "Batch",
      from: "Dari tanggal",
      to: "Sampai tanggal",
      onlyHidden: "Hanya yang disembunyikan",
      all: "Semua",
      reset: "Reset filter",
      results: "postingan ditemukan",
      empty: "Tidak ada postingan sesuai filter.",
      hide: "Sembunyikan",
      unhide: "Tampilkan",
      hidden: "Disembunyikan",
      pointsTitle: "Pengaturan Poin Jurnal",
      pointsSaved: "Pengaturan poin disimpan",
      foodPost: "Poin post jurnal makan",
      eduPost: "Poin post edukasi",
      comment: "Poin komentar",
      reaction: "Poin reaksi",
    },
    legal: {
      privacyTitle: "Kebijakan Privasi",
      termsTitle: "Syarat & Ketentuan",
      privacy: "Kebijakan Privasi",
      terms: "Syarat & Ketentuan",
      effective: "Berlaku sejak",
      version: "versi",
      whoWeAre: "Siapa kami",
      whoWeAreBody: "Layanan ini dikelola oleh {entity}, berkedudukan di {city}, {country}. Kebijakan ini menjelaskan data yang kami kumpulkan saat Anda mengikuti program dan bagaimana data itu kami gunakan.",
      contact: "Kontak",
      dataWeStore: "Data yang kami simpan",
      whyWeStore: "Mengapa kami menyimpannya",
      whyWeStoreBody: "Data dipakai untuk menjalankan program Anda: memverifikasi pembayaran, membuka materi edukasi sesuai jadwal, memberi umpan balik dari Coach, menghitung progres serta poin komunitas, dan mengirim pengingat. Kami tidak menjual data Anda kepada pihak ketiga.",
      whoSees: "Siapa yang dapat melihat",
      whoSeesBody: "Postingan di Jurnal Makan terlihat oleh seluruh Member dan Coach dalam Program + Batch yang sama. Data timbang dan foto progres hanya terlihat oleh Anda, Coach Anda, dan Administrator. Hasil akhir dapat ditampilkan di Recognition Wall batch Anda. Untuk pengiriman email dan penyimpanan berkas, kami memakai penyedia layanan pihak ketiga yang hanya memproses data atas perintah kami.",
      retention: "Berapa lama disimpan",
      retentionBody: "Data disimpan selama akun Anda aktif. Bila akun Anda dihapus, seluruh data pribadi, postingan, hasil timbang, dan foto ikut dihapus; hanya jejak audit tanpa identitas yang kami simpan untuk kebutuhan pertanggungjawaban keuangan.",
      yourRights: "Hak Anda",
      yourRightsBody: "Anda dapat meminta salinan, koreksi, atau penghapusan data Anda dengan menghubungi {email}. Permintaan penghapusan akan diproses dan tidak dapat dibatalkan setelah dijalankan.",
      security: "Keamanan",
      securityBody: "Kata sandi disimpan dalam bentuk hash, akses dibatasi berdasarkan peran, dan setiap tindakan administratif tercatat dalam jejak audit. Meski demikian, tidak ada sistem yang sepenuhnya bebas risiko — jaga kerahasiaan kata sandi Anda.",
      footerNote: "Dokumen ini dapat diperbarui. Perubahan penting akan kami informasikan melalui aplikasi atau email.",
      tService: "Tentang layanan",
      tServiceBody: "{entity} menyediakan program pendampingan penurunan berat badan berbasis edukasi harian, jurnal makan, dan pendampingan Coach. Dengan mendaftar, Anda menyetujui syarat ini.",
      tAccount: "Akun Anda",
      tAccountBody: "Anda wajib memberikan data yang benar, menjaga kerahasiaan kata sandi, dan tidak membagikan akun kepada orang lain. Satu akun untuk satu peserta.",
      tPayment: "Pembayaran",
      tPaymentBody: "Pembayaran dilakukan melalui transfer bank dengan mengunggah bukti transfer. Akses program terbuka setelah pembayaran diverifikasi Administrator. Nominal yang sudah diverifikasi tidak dapat dikembalikan kecuali batch dibatalkan oleh penyelenggara.",
      tContent: "Konten & komunitas",
      tContentBody: "Anda memegang hak atas foto dan tulisan yang Anda unggah, dan memberi kami izin menampilkannya kepada Member serta Coach dalam batch Anda. Konten yang mengandung kekerasan, pornografi, ujaran kebencian, atau promosi pihak lain dapat disembunyikan oleh Coach/Administrator.",
      tHealth: "Bukan nasihat medis",
      tHealthBody: "Materi dan umpan balik dalam program bersifat edukasi, bukan diagnosis atau resep medis. Konsultasikan dengan dokter bila Anda memiliki kondisi kesehatan tertentu, sedang hamil, menyusui, atau mengonsumsi obat rutin. Hasil setiap orang berbeda.",
      tCoach: "Program Coach",
      tCoachBody: "Untuk menjadi Coach, Anda wajib mengunggah bukti keanggotaan Herbalife resmi atau invoice resmi. Kelulusan ditentukan penyelenggara setelah bukti diverifikasi dan program 9 hari diselesaikan.",
      tTermination: "Penghentian akses",
      tTerminationBody: "Kami dapat menangguhkan atau menghapus akun yang melanggar syarat ini, memberikan data palsu, atau menyalahgunakan komunitas. Anda juga dapat meminta penghapusan akun kapan saja.",
      tLaw: "Hukum yang berlaku",
      tLawBody: "Syarat ini tunduk pada hukum {country} dan setiap sengketa diselesaikan di wilayah {city}.",
      settingsTitle: "Data Legal",
      settingsHint: "Data ini otomatis tampil di halaman Kebijakan Privasi dan Syarat & Ketentuan.",
      entityName: "Nama usaha/penyelenggara",
      contactEmail: "Email kontak",
      city: "Kota (yurisdiksi)",
      country: "Negara",
      whatsapp: "WhatsApp CS (opsional)",
      saved: "Data legal disimpan",
      agree: "Saya telah membaca dan menyetujui",
      agreeAnd: "dan",
      agreeRequired: "Anda harus menyetujui Syarat & Ketentuan serta Kebijakan Privasi.",
    },
    golive: {
      title: "Mode Go-Live",
      subtitle: "Satu tombol untuk membersihkan seluruh data uji dan membuka batch perdana.",
      c_accounts: "Akun uji",
      c_batches: "Batch uji",
      c_programs: "Program uji",
      c_journal_posts: "Postingan",
      c_measurements: "Data timbang",
      c_files: "File",
      rLegal: "Data legal (Privasi & S&K) sudah diisi",
      rPayment: "Ada rekening pembayaran aktif",
      rJourneys: "Ada journey edukasi yang dipublikasikan",
      rPrograms: "Ada program produksi",
      wipeDemo: "Hapus juga akun demo (*@fatloss.test)",
      createBatch: "Sekaligus buat batch perdana",
      batchHint: "Lengkapi program, kode, nama, dan tanggal mulai batch — atau matikan opsi ini.",
      program: "Program",
      code: "Kode batch",
      name: "Nama batch",
      start: "Tanggal mulai",
      capacity: "Kapasitas",
      warning: "Tindakan ini menghapus permanen seluruh akun uji beserta postingan, data timbang, dan filenya. Ketik GO-LIVE untuk konfirmasi.",
      run: "Jalankan Go-Live",
      done: "Go-Live selesai",
      batchCreated: "Batch perdana dibuat",
      remaining: "Sisa data",
    },
    reportPdf: "Unduh Rapor PDF",
    notifications: {
      title: "Notifikasi",
      empty: "Belum ada notifikasi.",
      readAll: "Tandai semua terbaca",
    },
    qualification: {
      title: "Kualifikasi Coach",
      subtitle: "Selesaikan seluruh hari kualifikasi untuk diajukan ke peninjauan",
      noApplication: "Anda belum mengajukan diri sebagai Coach. Ajukan dulu di halaman Perjalanan Saya.",
      noModules: "Hari kualifikasi belum tersedia. Hubungi tim Coach Development.",
      roleNote: "Peran Anda tetap Member sampai disetujui Administrator.",
    },
    edu: {
      title: "Perjalanan Edukasi",
      subtitle: "Materi harian yang terbuka bertahap, hari demi hari",
      journey: "Perjalanan",
      journeyName: "Nama perjalanan",
      journeyType: "Jenis perjalanan",
      durationDays: "Durasi (hari)",
      days: "hari",
      day: "Hari",
      of: "dari",
      daysDone: "hari selesai",
      state_COMPLETED: "SELESAI",
      state_AVAILABLE: "TERSEDIA",
      state_LOCKED: "TERKUNCI",
      unlocksOn: "Terbuka pada",
      availableOn: "Materi ini akan tersedia pada {date}.",
      availableDate: "Tersedia",
      finishPreviousDay: "Selesaikan Hari {day} terlebih dahulu untuk membuka materi ini.",
      notEligible: "Belum memenuhi syarat untuk memulai",
      joinedDay: "Mulai dari Hari",
      noDays: "Belum ada hari yang dipublikasikan.",
      noJourney: "Belum ada perjalanan edukasi untuk Anda. Aktifkan keanggotaan terlebih dahulu.",
      completeDay: "Selesaikan Hari Ini",
      dayCompleted: "Hari ini selesai. Hari berikutnya terbuka.",
      saved: "Progres disimpan",
      markVideoWatched: "Saya sudah menonton video",
      markMaterialRead: "Saya sudah membaca materi",
      openPdf: "Buka dokumen PDF",
      reflectionPlaceholder: "Tulis refleksi Anda (minimal 10 karakter)...",
      learnerView: "Tampilan Member",
      coachTab: "Program Coach 9 Hari",
      coachTabHint: "Program 9 Hari untuk Coach: hari terbuka berurutan mengikuti tanggal Anda diangkat sebagai Coach.",
      memberTab: "Program Member (Pratinjau)",
      noCoachJourney: "Program Coach 9 Hari belum tersedia.",
      cms: "Kelola Materi",
      newJourney: "Perjalanan Baru",
      newDay: "Hari Baru",
      journeyCreated: "Perjalanan dibuat",
      reordered: "Urutan hari diperbarui",
      duplicated: "Hari diduplikasi",
      contentItems: "item konten",
      addItem: "Tambah Item",
      type_VIDEO: "Video",
      type_TEXT: "Materi Teks",
      type_IMAGE: "Gambar",
      type_PDF: "PDF",
      type_CHECKLIST: "Checklist",
      type_QUIZ: "Kuis",
      type_REFLECTION: "Refleksi",
    },
    users: {
      eyebrow: "Master Admin",
      title: "Kelola Pengguna",
      subtitle: "Tangguhkan, aktifkan, ubah peran, dan atur izin akun",
      search: "Cari",
      empty: "Tidak ada pengguna yang cocok.",
      activate: "Aktifkan",
      suspend: "Tangguhkan",
      deactivate: "Nonaktifkan",
      sendReset: "Kirim Reset",
      resendInvite: "Kirim Ulang Undangan",
      permissions: "Izin",
      permissionsHint: "Izin tambahan khusus untuk akun Co-Admin ini.",
      delete: "Hapus",
      deleteTitle: "Hapus pengguna secara permanen",
      deleteWarning: "Seluruh data pengguna ikut terhapus: postingan jurnal makan, komentar, reaksi, poin, data timbang, progres edukasi, pembayaran, enrollment, notifikasi, dan semua foto yang diunggah. Jejak audit disimpan tanpa identitas. Tindakan ini tidak bisa dibatalkan.",
      deleteConfirmLabel: "Ketik ulang email pengguna untuk konfirmasi: {email}",
      deleteConfirmBtn: "Hapus Permanen",
      deleted: "Pengguna dihapus beserta {count} data terkait",
      statusChanged: "Status akun diperbarui",
      roleChanged: "Peran akun diperbarui",
      resetSent: "Tautan reset dikirim",
      inviteResent: "Undangan dikirim ulang",
      lastLogin: "Masuk terakhir",
      extraPerms: "izin tambahan",
      startDate: "Mulai",
      expirationDate: "Berakhir",
      daysRemaining: "hari tersisa",
      editExpiration: "Ubah Tanggal Berakhir",
      newExpiration: "Tanggal berakhir baru",
      reason: "Alasan",
      reasonPlaceholder: "mis. perpanjangan enrollment",
      expirationSaved: "Tanggal berakhir diperbarui",
    },
    landing: {
      eyebrow: "Program Penurunan Lemak Terpandu",
      heroTitle: "Turunkan lemak dengan pendampingan Coach, bukan sekadar niat",
      heroBody: "Program terstruktur dengan materi edukasi harian, Coach pendamping, dan biaya layanan yang transparan. Daftar sebagai Member dan mulai batch berikutnya.",
      howTitle: "Cara Kerjanya",
      step1Title: "Daftar sebagai Member",
      step1Body: "Isi data, pilih program, dan sebutkan preferensi Coach Anda. Verifikasi email untuk mengaktifkan akun.",
      step2Title: "Bayar Support Service Fee",
      step2Body: "Transfer tepat sesuai nominal unik Anda, lalu unggah foto bukti transfer langsung dari ponsel.",
      step3Title: "Verifikasi & Aktivasi",
      step3Body: "Tim Keuangan memverifikasi pembayaran, lalu Master Admin mengaktifkan keanggotaan Anda.",
      step4Title: "Jalani Program",
      step4Body: "Materi edukasi terbuka bertahap setiap hari dan Coach Anda memantau perkembangan.",
      feeTitle: "Biaya Transparan",
      feeBody: "Support Service Fee terdiri dari biaya dasar Rp50.000 ditambah nomor urut peserta Anda sebagai kode unik. Kode unik ini membuat setiap transfer mudah diverifikasi tanpa tertukar.",
      feePoint1: "Tidak ada biaya tersembunyi",
      feePoint2: "Nominal dihitung otomatis oleh sistem",
      feePoint3: "Bukti transfer diunggah langsung dari ponsel",
      programsTitle: "Program & Batch Terbuka",
      noOpenBatch: "Belum ada batch terbuka saat ini.",
      seatsLeft: "kursi tersisa",
      coachTitle: "Peran Coach",
      galleryTitle: "Galeri Transformasi",
      galleryBody: "Lima hasil terbaik peserta kami, diukur pada Final Hari 15 program: foto sebelum-sesudah beserta angka penurunannya.",
      galleryConsentNote: "Semua foto ditampilkan atas persetujuan peserta, dengan nama disingkat.",
      coachBody: "Setiap Member didampingi seorang Coach. Member yang telah menjalani program dapat mengikuti Kualifikasi Coach dan, setelah disetujui Administrator, mendampingi Member baru.",
      faqTitle: "Pertanyaan Umum",
      faq1Q: "Berapa total biaya yang harus saya transfer?",
      faq1A: "Rp50.000 ditambah nomor urut peserta Anda. Nominal tepatnya muncul di halaman pembayaran setelah akun Anda aktif.",
      faq2Q: "Bisakah saya mendaftar langsung sebagai Coach?",
      faq2A: "Tidak. Akun Coach hanya dibuat oleh Administrator atau melalui program Kualifikasi Coach bagi Member.",
      faq3Q: "Apakah saya bisa memilih Coach?",
      faq3A: "Anda dapat menyebutkan preferensi saat mendaftar. Penugasan akhir ditentukan Administrator sesuai ketersediaan.",
      faq4Q: "Kapan materi edukasi terbuka?",
      faq4A: "Materi harian terbuka bertahap: Hari 1, Hari 2, dan seterusnya, mengikuti tanggal mulai batch Anda.",
      ctaTitle: "Siap memulai transformasi Anda?",
      ctaBody: "Daftar hari ini, ikuti batch berikutnya, dan dapatkan pendampingan Coach sepanjang program.",
    },
    education: {
      eyebrow: "Edukasi",
      title: "Modul Edukasi",
      subtitle: "Materi harian yang terbuka bertahap sesuai jadwal batch",
      preview: "Tampilan Peserta",
      newModule: "Modul Baru",
      week: "Minggu",
      moduleTitle: "Judul Modul",
      summary: "Ringkasan singkat",
      content: "Isi Materi",
      contentHint: "Tulis materi edukasi di sini…",
      videoUrl: "Tautan video YouTube (opsional)",
      isQualification: "Modul Kualifikasi Coach",
      isQualificationHint: "Penanda warisan untuk modul mingguan lama; materi kualifikasi Coach kini dikelola melalui Perjalanan Edukasi harian.",
      quizQuestion: "Pertanyaan kuis",
      quizOption: "Pilihan",
      addQuestion: "Tambah Pertanyaan",
      publish: "Terbitkan",
      unpublish: "Tarik",
      confirmDelete: "Hapus modul ini?",
      noModules: "Belum ada modul untuk program ini.",
      noModulesYet: "Materi belum tersedia.",
      noJourney: "Belum ada batch aktif. Materi akan muncul setelah pembayaran Anda disetujui.",
      thisWeek: "Minggu ini",
      unlocksOn: "Terbuka pada",
      open: "Terbuka",
    },
    admin: {
      revenue: "Pendapatan",
      approvedPayments: "pembayaran disetujui",
      pendingPayments: "Menunggu Persetujuan",
      members: "Anggota",
      pendingCandidates: "Kandidat Coach",
      modulesPublished: "modul terbit",
      batchTable: "Peserta per Batch",
      participants: "Peserta",
      activeParticipants: "peserta aktif",
      inQualification: "dalam kualifikasi",
      activeMembers: "Member Aktif",
      activeCoaches: "Coach Aktif",
      activeEnrollment: "Enrollment Aktif",
      expiredEnrollment: "Enrollment Berakhir",
      expiredEnrollmentSub: "perlu enrollment ulang",
      withEnrollment: "ada enrollment",
      expiredShort: "expired",
      expiring7: "≤7 hari",
      expiring14: "≤14 hari",
    },
    progress: {
      title: "Progres Harian Member",
      members: "member aktif",
      behind: "tertinggal",
      behindBadge: "Tertinggal",
      allCoaches: "Semua Coach",
      unassigned: "Belum ada Coach",
      empty: "Belum ada member aktif yang ditugaskan.",
      lastDone: "Terakhir selesai",
      expected: "seharusnya hari",
      noJourney: "Belum ada perjalanan edukasi",
    },
    programs: {
      eyebrow: "Katalog",
      title: "Program & Batch",
      subtitle: "Kelola program penurunan lemak dan batch pelaksanaannya",
      newProgram: "Program Baru",
      editProgram: "Ubah Program",
      name: "Nama Program",
      description: "Deskripsi",
      durationDays: "Durasi (hari)",
      days: "hari",
      calendarDays: "hari kalender",
      durationMismatch: "Tanggal batch tidak selaras dengan durasi program",
      alignedEnd: "selesai jika selaras:",
      empty: "Belum ada program.",
      confirmDelete: "Hapus program ini?",
      confirmDeleteBatch: "Hapus batch ini?",
      batches: "Batch",
      newBatch: "Batch Baru",
      noBatches: "Belum ada batch untuk program ini.",
      batchName: "Nama Batch",
      batchCode: "Kode Batch",
      startDate: "Tanggal Mulai",
      endDate: "Tanggal Selesai",
      capacity: "Kapasitas",
      feeAmount: "Support Service Fee (IDR)",
      coaches: "Coach",
      noCoach: "Belum ditugaskan",
      pickCoach: "Pilih Coach",
      assign: "Tugaskan",
      coachAssigned: "Coach ditugaskan",
    },
    payments: {
      eyebrow: "Keuangan",
      queueTitle: "Antrean Pembayaran",
      queueSubtitle: "Setujui atau tolak pembayaran Support Service Fee",
      queueEmpty: "Tidak ada pembayaran.",
      tabPENDING: "Menunggu",
      tabAPPROVED: "Disetujui",
      tabREJECTED: "Ditolak",
      tabALL: "Semua",
      approve: "Setujui",
      reject: "Tolak",
      approved: "Pembayaran disetujui",
      rejected: "Pembayaran ditolak",
      rejectReason: "Alasan penolakan",
      confirmReject: "Konfirmasi Tolak",
      viewProof: "Lihat bukti",
      source: "Sumber",
      payAndEnroll: "Bayar & Daftar",
      payTitle: "Pembayaran Support Service Fee",
      transferTo: "Transfer ke",
      proofUrl: "Tautan bukti transfer",
      note: "Catatan (opsional)",
      submit: "Kirim Pembayaran",
      submitted: "Pembayaran dikirim, menunggu verifikasi",
      manualCreate: "Input Manual",
      memberEmail: "Email Anggota",
      amount: "Jumlah (IDR)",
      proofImage: "Foto bukti transfer",
      tapToUpload: "Ketuk untuk memotret / memilih foto",
      uploading: "Mengunggah…",
      uploaded: "Foto terunggah",
      fileType: "Hanya JPG, PNG atau WEBP",
      fileSize: "Ukuran maksimal 5 MB",
      optimizing: "Mengoptimalkan…",
      processError: "Foto belum dapat diproses. Silakan coba pilih foto lain.",
      proofHint: "Foto otomatis dioptimalkan · JPG / PNG / WEBP",
      proofRequired: "Unggah foto bukti transfer dulu",
      participantCode: "Participant Code",
      baseFee: "Support Service Fee",
      uniqueCode: "Kode Unik",
      totalToPay: "Total Transfer",
      exactAmountHint: "Transfer tepat sesuai nominal (termasuk kode unik) agar pembayaran dapat diverifikasi.",
      mismatch: "Nominal Tidak Sesuai",
      mismatchReason: "Catatan ketidaksesuaian",
      confirmMismatch: "Tandai Tidak Sesuai",
      mismatched: "Pembayaran ditandai tidak sesuai; anggota dapat mengirim ulang",
      tabMISMATCH: "Tidak Sesuai",
      alreadyEnrolled: "Anda sudah terdaftar di batch ini. Lihat status di Perjalanan Saya.",
      method_BANK_TRANSFER: "Transfer Bank",
      destination: "Rekening tujuan",
      copyAccount: "Salin No. Rekening",
      copyAmount: "Salin Nominal",
      copiedAccount: "Nomor rekening disalin",
      copiedAmount: "Nominal disalin",
      copyFailed: "Gagal menyalin, silakan salin manual",
    },
    enrollments: {
      title: "Peserta",
      empty: "Belum ada peserta di batch ini.",
      activate: "Aktifkan",
      activated: "Enrollment diaktifkan",
      create: "Buat Enrollment",
      created: "Enrollment dibuat",
      manualHint: "Daftarkan anggota secara manual. Participant Code dan total transfer dihitung otomatis oleh sistem (Rp50.000 + nomor urut).",
    },
    coach: {
      eyebrow: "Coach Development",
      title: "Kandidat Coach",
      tabIN_QUALIFICATION: "Kualifikasi",
      tabWAITING_REVIEW: "Menunggu Review",
      tabAPPROVED: "Disetujui",
      tabREJECTED: "Ditolak",
      tabALL: "Semua",
      progress: "Progres kualifikasi",
      progressSaved: "Progres tersimpan",
      proofTitle: "Bukti Keanggotaan Herbalife",
      proofNone: "Kandidat belum mengunggah bukti keanggotaan.",
      proofStatus_PENDING: "Menunggu verifikasi",
      proofStatus_APPROVED: "Bukti disetujui",
      proofStatus_REJECTED: "Bukti ditolak",
      proofApprove: "Setujui Bukti",
      proofReject: "Tolak Bukti",
      proofApproved: "Bukti disetujui",
      proofRejected: "Bukti ditolak — kandidat diminta unggah ulang",
      proofNote: "Catatan untuk kandidat (opsional)",
      proofView: "Lihat ukuran penuh",
      saveProgress: "Simpan",
      markComplete: "Tandai 100%",
      qualifyingInfo: "Anda sedang dalam proses kualifikasi Coach. Peran Anda tetap Anggota hingga disetujui.",
      subtitle: "Pantau kualifikasi, tinjau kandidat, dan berikan peran Coach",
      empty: "Tidak ada kandidat.",
      addCandidate: "Tambah Kandidat",
      added: "Kandidat ditambahkan",
      note: "Catatan",
      review: "Tinjau",
      approve: "Setujui & Jadikan Coach",
      approvedMsg: "Kandidat disetujui, peran Coach diberikan",
      rejectedMsg: "Kandidat ditolak",
      activeEnrollments: "Enrollment aktif",
      becomeCoach: "Jadi Coach",
      applyInfo: "Sudah menjalani program? Ajukan diri Anda untuk menjadi Coach. Setelah kualifikasi 100% selesai, tim Coach Development akan meninjau pengajuan Anda.",
      motivation: "Motivasi Anda",
      proof: "Bukti keanggotaan Herbalife",
      proofHint: "Unggah screenshot keanggotaan Herbalife resmi atau invoice resmi Anda sebagai member M100 (JPG/PNG/HEIC, maks 10MB).",
      proofRequired: "Unggah bukti keanggotaan Herbalife resmi atau invoice resmi terlebih dahulu.",
      programAfterApproval: "Program Coach 9 Hari akan terbuka di menu Edukasi setelah pengajuan Anda disetujui.",
      apply: "Ajukan Diri",
      applied: "Pengajuan terkirim",
      pendingInfo: "Pengajuan Anda sedang ditinjau.",
    },
    journey: {
      eyebrow: "Anggota",
      title: "Perjalanan Saya",
      subtitle: "Enrollment, pembayaran, dan Participant Code Anda",
      browse: "Lihat Program",
      enrollments: "Enrollment",
      noEnrollments: "Belum ada enrollment. Pilih batch di halaman Program.",
      payments: "Riwayat Pembayaran",
      myMembers: "Anggota Saya",
      noMembers: "Belum ada anggota yang ditugaskan kepada Anda.",
      noPayments: "Belum ada pembayaran.",
    },
    validation: {
      required: "Wajib diisi",
      emailInvalid: "Format email tidak valid",
      passwordWeak: "Kata sandi minimal 8 karakter dengan huruf besar, kecil dan angka",
      passwordMismatch: "Kata sandi tidak cocok",
      whatsappInvalid: "Format nomor WhatsApp tidak valid",
    },
    auth: {
      loginTitle: "Masuk ke Fat Loss Program",
      loginSubtitle: "Satu akun untuk Member, Coach, dan Administrator",
      coachInfoTitle: "Coach",
      coachInfoBody: "Sudah memiliki akun Coach? Masuk menggunakan akun yang diberikan oleh Administrator.",
      registerTitle: "Daftar sebagai Member",
      registerSubtitle: "Mulai program penurunan lemak Anda hari ini",
      stepAccount: "Akun",
      stepProfile: "Profil",
      stepProgram: "Program",
      stepReview: "Tinjau",
      regNext: "Lanjut",
      regProgram: "Program",
      regProgramNone: "Belum menentukan",
      regCoach: "Preferensi Coach",
      regCoachAny: "Tidak ada preferensi / Ditentukan Admin",
      regCoachHint: "Preferensi Anda menjadi pertimbangan; penugasan akhir ditentukan Administrator.",
      regWhatsappHint: "Opsional. Digunakan untuk komunikasi program.",
      inviteCoach: "Buat Akun Coach",
      inviteSend: "Kirim Undangan",
      inviteSent: "Undangan Coach terkirim",
      inviteHint: "Sistem membuat akun dengan peran Coach lalu mengirim tautan undangan. Coach mengatur kata sandinya sendiri — tidak ada kata sandi yang dikirim melalui email.",
      inviteAcceptTitle: "Aktivasi Akun Coach",
      inviteAcceptSubtitle: "Atur kata sandi Anda untuk mengaktifkan akun.",
      inviteSetPassword: "Atur Kata Sandi",
      inviteAccepted: "Akun aktif. Silakan masuk.",
      suspended: "Akun Anda ditangguhkan. Hubungi Administrator.",
      deactivated: "Akun Anda dinonaktifkan. Hubungi Administrator.",
      tokenInvalid: "Tautan tidak valid atau sudah digunakan.",
      tokenExpired: "Tautan sudah kedaluwarsa.",
      loginSubmit: "Masuk",
      rememberMe: "Tetap masuk di perangkat ini",
      showPassword: "Tampilkan kata sandi",
      hidePassword: "Sembunyikan kata sandi",
      registerSubmit: "Buat Akun",
      registerSuccess: "Akun dibuat. Tautan verifikasi telah dikirim ke email Anda.",
      forgotTitle: "Lupa Kata Sandi?",
      forgotSubtitle: "Masukkan email Anda dan kami akan mengirimkan tautan reset.",
      forgotSubmit: "Kirim Tautan Reset",
      forgotSent: "Jika email Anda terdaftar, tautan reset telah dikirim.",
      previewLabel: "Preview tautan (akun uji)",
      resetTitle: "Atur Ulang Kata Sandi",
      resetSubtitle: "Pilih kata sandi baru untuk akun Anda.",
      newPassword: "Kata Sandi Baru",
      resetSubmit: "Atur Ulang Kata Sandi",
      resetSuccess: "Kata sandi berhasil diatur ulang. Silakan masuk.",
      verifyTitle: "Verifikasi Email",
      verifying: "Memverifikasi email Anda…",
      verifySuccess: "Email berhasil diverifikasi. Anda dapat masuk sekarang.",
      verifyFail: "Tautan verifikasi tidak valid atau kedaluwarsa.",
      verifyRequired: "Email belum diverifikasi",
      verifyPlease: "Verifikasi email Anda terlebih dahulu.",
      resendVerification: "Kirim ulang email verifikasi",
      resendSent: "Jika email Anda terdaftar, email verifikasi telah dikirim.",
      alreadyAccount: "Sudah punya akun?",
      noAccount: "Belum punya akun?",
      forgotLink: "Lupa Kata Sandi?",
      loginLink: "Masuk",
      registerLink: "Daftar sebagai Member",
      invalidCredentials: "Email atau kata sandi salah",
      emailTaken: "Email sudah terdaftar",
      locked: "Terlalu banyak percobaan gagal. Coba lagi nanti.",
      rateLimited: "Terlalu banyak permintaan. Coba lagi nanti.",
    },
    dashboard: {
      welcome: "Selamat datang kembali",
      scope_member: "Dashboard Member",
      scope_coach: "Dashboard Coach",
      scope_admin: "Command Center",
      hint_member: "Kelola enrollment, pembayaran Support Service Fee, dan Participant Code Anda.",
      hint_coach: "Pantau anggota yang ditugaskan kepada Anda dan materi edukasi mereka.",
      hint_admin: "Metrik, verifikasi pembayaran, dan pengelolaan program sesuai izin akun Anda.",
      role: "Peran",
      status: "Status",
      preview: "Program, Batch, Pembayaran dan Kandidat Coach kini aktif. Modul Edukasi & Jurnal Makanan menyusul di fase berikutnya.",
      profile: "Profil",
      viewProfile: "Lihat Profil",
    },
    profile: {
      title: "Profil Saya",
      subtitle: "Perbarui informasi profil Anda",
      preferences: "Preferensi",
      saved: "Perubahan tersimpan",
      viewPreference: "Preferensi Tampilan",
      auto: "Otomatis",
      mobile: "Mobile",
      desktop: "Desktop",
    },
    roles: {
      MASTER_ADMIN: "Master Admin",
      CO_ADMIN: "Co-Admin",
      COACH: "Coach",
      MEMBER: "Anggota",
    },
  },
  en: {
    common: {
      appName: "Fat Loss Program",
      appTagline: "Discipline-driven body transformation",
      backToHome: "Home",
      loading: "Loading…",
      save: "Save",
      cancel: "Cancel",
      submit: "Submit",
      back: "Back",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      fullName: "Full Name",
      whatsapp: "WhatsApp Number (optional)",
      language: "Language",
      logout: "Logout",
      status: "Status",
      edit: "Edit",
      delete: "Delete",
      deleted: "Deleted",
      saved: "Saved",
      yes: "Yes",
      no: "No",
      selectDate: "Pick a date",
    },
    upload: {
      choose: "Choose a photo",
      camera: "📷 Take Photo",
      gallery: "🖼️ Choose from Gallery / Files",
      uploading: "Uploading…",
      optimizing: "Optimizing photo…",
      done: "Photo ready",
      tooLarge: "Maximum file size is 10 MB",
      tooLargeToProcess: "This photo is too large to process. Please pick another one.",
      processError: "This photo couldn't be processed. Please try another one.",
      mimeError: "Unsupported format. Please choose a JPG, PNG or WEBP photo.",
      hint: "JPG / PNG / WEBP / HEIC · max 10 MB",
      hintCompress: "Photos are optimized automatically before upload · JPG / PNG / WEBP",
    },
    storage: {
      title: "Storage Savings",
      subtitle: "Automatic photo compression summary",
      totalPhotos: "Total photos",
      stored: "Stored size",
      original: "Original size",
      saved: "Total saved",
      avgRatio: "Average compression",
      optimized: "photos optimized",
      byKind: "Breakdown by type",
      kind: "Type",
      cdnTitle: "Image Delivery (Cloudflare R2)",
      cdnDesc: "Migrate photos to R2 & build thumbnails for old photos. Safe to re-run.",
      cdnEnabled: "R2 enabled",
      cdnDisabled: "R2 not configured",
      backfillRun: "Run Migration + Backfill",
      backfillRunning: "Migration running…",
      backfillMigrated: "Migrated",
      backfillThumbs: "Thumbnails built",
      backfillErrors: "Errors",
      backfillDone: "Done",
      backfillStarted: "Migration started in the background.",
    },
    streak: {
      days: "day streak",
      longest: "Longest streak",
      rule: "counted when Education & Food Journal are both done that day",
      education: "Today's material",
      journal: "Food journal",
      boardTitle: "Batch Streak Board",
      boardEmpty: "No active members in this batch yet.",
      coach: "Coach",
      noCoach: "No coach yet",
      daysDone: "material days done",
      record: "Best",
    },
    crm: {
      chatWhatsapp: "Chat on WhatsApp",
      openWhatsapp: "Open WhatsApp",
      noWhatsapp: "No WhatsApp number on file",
      lastReminded: "Last reminded",
      justNow: "just now",
      minAgo: "{n} min ago",
      hourAgo: "{n} h ago",
      dayAgo: "{n} d ago",
      dialogTitle: "Send a reminder",
      messageLabel: "Message (editable)",
      noteLabel: "Note about this member",
      notePlaceholder: "Short note, e.g. contacted, will log tonight",
      saveNote: "Save",
      noteSaved: "Note saved",
      defaultName: "Member",
      tplEducation: "Hi {name} 👋 Don't forget to complete today's education lesson. You got this! 💪",
      tplFoodJournal: "Hi {name} 👋 You haven't logged your food journal today. Please share your meals so we can track your progress 🍽️",
      save: "Save",
      templatesLabel: "Saved templates",
      saveAsTemplate: "Save as template",
      templateTitlePlaceholder: "Template title",
      templateSaved: "Template saved",
      templateDeleted: "Template deleted",
      noTemplates: "No templates yet",
      nameHint: "{name} is auto-replaced with the member's name",
      history: "Reminder history",
      historyEmpty: "Never reminded yet",
      ctxEducation: "Education",
      ctxFood: "Food Journal",
      behindOnly: "Behind only",
      missingOnly: "Not logged only",
    },
    food: {
      eyebrow: "Nutrition",
      title: "Food Journal",
      subtitleMember: "Log every meal with a photo — your Coach will give feedback",
      subtitleCoach: "Review and comment on member food journals",
      member: "Member",
      filterDate: "Date",
      empty: "No food journal entries yet.",
      mealType: "Meal",
      meal_SARAPAN: "Breakfast",
      meal_MAKAN_SIANG: "Lunch",
      meal_MAKAN_MALAM: "Dinner",
      meal_SNACK: "Snack",
      photo: "Meal photo",
      photoRequired: "Upload the meal photo first",
      note: "Note (optional)",
      save: "Save Entry",
      saving: "Saving…",
      saved: "Journal entry saved",
      confirmDelete: "Delete this entry?",
      comment: "Send",
      commentPlaceholder: "Write a comment…",
      adminReadOnly: "Administrators have read-only access.",
      audit: "AI Audit",
      reaudit: "Re-run Audit",
      auditDone: "AI audit complete",
      auditHint: "Lunch entries are analysed by AI automatically.",
      aiVerdict: "AI verdict",
      verdict_BAIK: "Good",
      verdict_CUKUP: "Fair",
      verdict_PERLU_PERBAIKAN: "Needs Work",
      tabMine: "My Journal",
      tabWall: "Food Wall",
      tabCompliance: "Today's Compliance",
      tabMember: "Member Journal",
      logged: "Logged",
      notLogged: "Not logged",
      statusLogged: "DONE",
      statusMissing: "MISSING",
      notLoggedToday: "No meal logged today",
      entriesToday: "entries",
      noMembers: "No active members yet.",
      openJournal: "Open Journal",
      dailySummary: "Daily Nutrition Recap",
      makeSummary: "Summarise Today",
      summarizing: "Summarising…",
      summaryDone: "Nutrition recap created",
      noSummary: "No recap yet. Log your meals then summarise, or wait for the automatic 20:00 WIB recap.",
      react: "React",
      locked: "The Food Journal unlocks once your account is activated.",
      tabFeed: "Batch Wall",
      newPost: "+ New Post",
      postFood: "Food Journal",
      postEducation: "Education Post",
      caption: "Caption",
      captionPlaceholder: "Write a caption, education, meal menu, or info for the community...",
      readMore: "Read more",
      showLess: "Show less",
      uploadedAt: "Uploaded",
      capturedAt: "Taken",
      captureUnknown: "Capture time unavailable",
      location: "Location",
      shareLocation: "Include my location",
      locationDenied: "Location not shared",
      reply: "Reply",
      replyPlaceholder: "Write a reply…",
      sending: "sending…",
      hide: "Hide",
      unhide: "Show",
      hidden: "HIDDEN",
      filterRole: "Role",
      filterType: "Type",
      filterBatch: "Batch",
      filterOwner: "Owner",
      all: "All",
      leaderboard: "Journal Activity",
      posts: "posts",
      pointsPerBatchNote: "Points are counted for the active batch only. Points from previous batches are not accumulated.",
      points: "points",
      aiLimit: "Your 1 AI Food Review for today is already used.",
      aiCached: "cached result",
    },
    branding: {
      eyebrow: "Appearance",
      title: "Branding",
      subtitle: "Control the logo, name, colours, landing copy and contacts",
      identity: "Identity",
      appName: "App Name",
      tagline: "Tagline",
      accent: "Accent Colour",
      logo: "Logo",
      removeLogo: "Remove Logo",
      hero: "Landing — Hero",
      heroEyebrow: "Eyebrow",
      heroTitle: "Headline",
      heroBody: "Description",
      steps: "Flow Steps",
      stepTitle: "Step Title",
      stepBody: "Step Description",
      faq: "FAQ",
      question: "Question",
      answer: "Answer",
      contact: "Contact & Social",
      whatsapp: "WhatsApp",
      email: "Email",
      addItem: "Add",
      save: "Save Changes",
      saved: "Branding saved",
      fallbackHint: "Leave empty to use the built-in copy.",
    },
    paymentSettings: {
      title: "Payment Settings",
      subtitle: "Manage the Support Service Fee destination account",
      sectionTitle: "Payment Destination Account",
      add: "+ Add Account",
      empty: "No accounts yet. Add a payment destination account.",
      bankName: "Bank Name",
      accountNumber: "Account Number",
      holderName: "Account Holder Name",
      displayLabel: "Display Label",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      default: "Default Account",
      setDefault: "Set as Default",
      activate: "Activate",
      deactivate: "Deactivate",
      save: "Save Changes",
      saved: "Changes saved",
      deleted: "Account deleted",
      confirmDefault: "Change the default payment destination? Future payment instructions will use this account.",
      confirmDelete: "Delete this account? It can no longer be used for new payments.",
      notSet: "Payment destination is not configured yet. Please contact the Administrator.",
    },
    nav: { programs: "Programs", journey: "My Journey", payments: "Payments", coachDev: "Coach Candidates", education: "Education", qualification: "Coach Qualification", users: "Users", paymentSettings: "Payment Settings", foodJournal: "Food Journal", branding: "Branding", measurements: "Measurements", recognition: "Recognition Wall", moderation: "Journal Moderation", groupProgram: "Program", groupLearning: "Learning", groupCommunity: "Community", groupSettings: "Settings" },
    measure: {
      eyebrow: "Physical Progress",
      title: "Measurements",
      subtitleMember: "Four checkpoints: Day 1, Day 6, Day 11 and Final Day 15",
      subtitleCoach: "Record weight, body fat and progress photos for your members",
      weight: "Weight (kg)",
      bodyFat: "Body fat (%)",
      baseline: "Baseline",
      final: "Final Result",
      deltaFromStart: "Change from start",
      deleteData: "Delete Data",
      dataDeleted: "Measurement deleted",
      confirmDelete: "Delete this checkpoint's measurement? Related photos are removed and this cannot be undone.",
      sortBy: "Sort",
      sort_behind: "Most behind",
      sort_filled: "Most complete",
      sort_name: "Name",
      photo_before: "Before photo (Day 1)",
      photo_after: "After photo (Final Day 15)",
      photoNumbersOnly: "This checkpoint records numbers only (no photo).",
      batch: "Batch",
      member: "Member",
      pickMember: "Select member",
      due: "Scheduled",
      noSchedule: "Schedule not available",
      status_FILLED: "Recorded",
      status_DUE_TODAY: "Weigh-in today",
      status_OVERDUE: "Missed",
      status_UPCOMING: "Upcoming",
      status_PENDING: "Not filled",
      weightBefore: "Weight before (kg)",
      weightAfter: "Weight after (kg)",
      fatBefore: "Body fat before (%)",
      fatAfter: "Body fat after (%)",
      photoBefore: "Photo before",
      photoAfter: "Photo after",
      photoFinalOnly: "Before & after photos are only uploaded at Final Day 15.",
      deletePhoto: "Delete photo",
      photoDeleted: "Photo deleted",
      galleryConsent: "Show this transformation in the public landing-page gallery (shortened name, e.g. \"Andrie S.\")",
      galleryOn: "Shown in the public gallery",
      galleryOff: "Removed from the public gallery",
      note: "Coach note",
      record: "Record data",
      edit: "Edit data",
      saved: "Measurement saved",
      trend: "Trend chart",
      trendWeight: "Weight (kg)",
      trendFat: "Body fat (%)",
      noData: "No measurement data yet.",
      readOnly: "Only Coaches can fill in measurements.",
      delta: "Delta",
      filled: "checkpoints filled",
      reminderHint: "Automatic reminders go to the member and coach on the morning of the due date (07:00 WIB).",
    },
    recog: {
      eyebrow: "Recognition",
      title: "Recognition Wall",
      subtitle: "Top 10 Final Day 15 results per batch + weekly activity",
      week: "Week",
      champion: "Member of the Week",
      pinned: "Coach's pick",
      pin: "Pin",
      unpin: "Remove pin",
      pinNote: "Reason (optional)",
      pinned_ok: "Member pinned",
      unpinned_ok: "Pin removed",
      score: "Score",
      points: "Journal points",
      streak: "Streak",
      compliance: "Compliance",
      weightLost: "Weight lost",
      fatLost: "Body fat lost",
      ranking: "This week's ranking",
      finals: "Final Day 15 results",
      before: "Before",
      after: "After",
      downloadCard: "Download Transformation Card",
      empty: "No activity this week yet.",
      tab_top: "Top 10 Final Results",
      tab_weekly: "Weekly Activity",
      board_member_weight: "Top 10 Members — Most Weight Lost",
      board_member_fat: "Top 10 Members — Most Body Fat % Lost",
      board_coach_weight: "Top 10 Coaches — Most Weight Lost",
      board_coach_fat: "Top 10 Coaches — Most Body Fat % Lost",
      displayMode: "Show on Recognition Wall",
      mode_BOTH: "Coaches & Members side by side",
      mode_MEMBER_ONLY: "Members only",
      mode_COACH_ONLY: "Coaches only",
      modeSaved: "Display setting saved",
      topSource: "Taken from this batch's Final Day 15 measurements — up to {n} names per category.",
      topHint: "Only participants with an actual loss (positive number) appear here.",
      noFinals: "No Final Day 15 data in this batch yet.",
      inGallery: "In public gallery",
      formula: "Score = journal points + streak×5 + compliance×20 + kg lost×10 + body fat % lost×5",
    },
    del: {
      manage: "Manage/Delete",
      batchTitle: "Delete batch & its participants",
      programTitle: "Delete programme, batches & participants",
      warning: "This is permanent. User accounts are NOT deleted — only their participation and data inside this batch.",
      typeToConfirm: 'Type "{word}" to confirm',
      clearBatch: "Clear batch",
      forceDelete: "Delete permanently",
      cleared: "{n} participants removed, batch kept",
      deleted: "Deleted successfully",
      confirmEnrollment: "Remove {name} from this batch along with their payments, measurements and journal posts?",
      enrollmentDeleted: "Participant removed from the batch",
      c_enrollments: "Participants",
      c_active_enrollments: "Active participants",
      c_payments: "Payments",
      c_measurements: "Measurements",
      c_journal_posts: "Journal posts",
      c_comments: "Comments",
      c_reactions: "Reactions",
      c_journal_points: "Journal points",
      c_recognition_pins: "Pins",
      c_batches: "Batches",
    },
    mod: {
      eyebrow: "Moderation",
      title: "Journal Moderation",
      subtitle: "Filter journal posts by batch, date range and hidden state",
      batch: "Batch",
      from: "From date",
      to: "To date",
      onlyHidden: "Hidden only",
      all: "All",
      reset: "Reset filters",
      results: "posts found",
      empty: "No posts match the filters.",
      hide: "Hide",
      unhide: "Unhide",
      hidden: "Hidden",
      pointsTitle: "Journal points settings",
      pointsSaved: "Points settings saved",
      foodPost: "Food journal post points",
      eduPost: "Education post points",
      comment: "Comment points",
      reaction: "Reaction points",
    },
    legal: {
      privacyTitle: "Privacy Policy",
      termsTitle: "Terms & Conditions",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      effective: "Effective from",
      version: "version",
      whoWeAre: "Who we are",
      whoWeAreBody: "This service is operated by {entity}, based in {city}, {country}. This policy explains what we collect while you follow the programme and how we use it.",
      contact: "Contact",
      dataWeStore: "What we store",
      whyWeStore: "Why we store it",
      whyWeStoreBody: "Your data runs your programme: verifying payments, unlocking education on schedule, delivering Coach feedback, computing progress and community points, and sending reminders. We do not sell your data.",
      whoSees: "Who can see it",
      whoSeesBody: "Food Journal posts are visible to every Member and Coach in the same Programme + Batch. Measurements and body photos are visible only to you, your Coach and Administrators. Final results may be featured on your batch Recognition Wall. We use third-party providers for email delivery and file storage, which process data only on our instructions.",
      retention: "How long we keep it",
      retentionBody: "Data is kept while your account is active. If your account is deleted, all personal data, posts, measurements and photos are deleted with it; only de-identified audit trails are retained for financial accountability.",
      yourRights: "Your rights",
      yourRightsBody: "You may request a copy, a correction or the deletion of your data by contacting {email}. Deletion is irreversible once executed.",
      security: "Security",
      securityBody: "Passwords are stored hashed, access is limited by role and every administrative action is written to an audit trail. No system is risk-free, so please keep your password private.",
      footerNote: "This document may be updated. We will announce material changes in the app or by email.",
      tService: "About the service",
      tServiceBody: "{entity} provides a guided fat-loss programme built on daily education, a food journal and Coach support. By registering you accept these terms.",
      tAccount: "Your account",
      tAccountBody: "You must provide accurate details, keep your password private and not share your account. One account per participant.",
      tPayment: "Payments",
      tPaymentBody: "Payment is made by bank transfer with an uploaded proof. Access opens once an Administrator verifies the payment. Verified amounts are non-refundable unless the organiser cancels the batch.",
      tContent: "Content & community",
      tContentBody: "You keep the rights to the photos and text you upload and grant us permission to display them to Members and Coaches in your batch. Violent, pornographic, hateful or third-party promotional content may be hidden by a Coach or Administrator.",
      tHealth: "Not medical advice",
      tHealthBody: "Programme material and feedback are educational, not a diagnosis or prescription. Consult a doctor if you have a medical condition, are pregnant or breastfeeding, or take regular medication. Results vary per person.",
      tCoach: "Coach programme",
      tCoachBody: "To become a Coach you must upload official Herbalife membership proof or an official invoice. Graduation is decided by the organiser after the proof is verified and the 9-day programme is completed.",
      tTermination: "Ending access",
      tTerminationBody: "We may suspend or delete accounts that breach these terms, submit false information or abuse the community. You may also request deletion at any time.",
      tLaw: "Governing law",
      tLawBody: "These terms are governed by the laws of {country} and disputes are settled in {city}.",
      settingsTitle: "Legal details",
      settingsHint: "These details appear automatically on the Privacy Policy and Terms pages.",
      entityName: "Business / organiser name",
      contactEmail: "Contact email",
      city: "City (jurisdiction)",
      country: "Country",
      whatsapp: "Support WhatsApp (optional)",
      saved: "Legal details saved",
      agree: "I have read and agree to the",
      agreeAnd: "and the",
      agreeRequired: "You must accept the Terms & Conditions and the Privacy Policy.",
    },
    golive: {
      title: "Go-Live mode",
      subtitle: "One action that wipes every test artefact and opens your first real batch.",
      c_accounts: "Test accounts",
      c_batches: "Test batches",
      c_programs: "Test programmes",
      c_journal_posts: "Posts",
      c_measurements: "Measurements",
      c_files: "Files",
      rLegal: "Legal details (Privacy & Terms) filled in",
      rPayment: "An active payment account exists",
      rJourneys: "At least one published education journey",
      rPrograms: "At least one production programme",
      wipeDemo: "Also delete the demo accounts (*@fatloss.test)",
      createBatch: "Also create the first batch",
      batchHint: "Fill in the batch programme, code, name and start date — or turn this option off.",
      program: "Programme",
      code: "Batch code",
      name: "Batch name",
      start: "Start date",
      capacity: "Capacity",
      warning: "This permanently deletes every test account along with its posts, measurements and files. Type GO-LIVE to confirm.",
      run: "Run Go-Live",
      done: "Go-Live complete",
      batchCreated: "First batch created",
      remaining: "Remaining data",
    },
    reportPdf: "Download PDF report",
    notifications: {
      title: "Notifications",
      empty: "No notifications yet.",
      readAll: "Mark all as read",
    },
    qualification: {
      title: "Coach Qualification",
      subtitle: "Complete every qualification day to be submitted for review",
      noApplication: "You have not applied to become a Coach yet. Apply first on the My Journey page.",
      noModules: "No qualification days available yet. Contact the Coach Development team.",
      roleNote: "Your role stays Member until an Administrator approves it.",
    },
    edu: {
      title: "Education Journey",
      subtitle: "Daily material that unlocks step by step, day by day",
      journey: "Journey",
      journeyName: "Journey name",
      journeyType: "Journey type",
      durationDays: "Duration (days)",
      days: "days",
      day: "Day",
      of: "of",
      daysDone: "days completed",
      state_COMPLETED: "COMPLETED",
      state_AVAILABLE: "AVAILABLE",
      state_LOCKED: "LOCKED",
      unlocksOn: "Unlocks on",
      availableOn: "This material unlocks on {date}.",
      availableDate: "Available",
      finishPreviousDay: "Finish Day {day} first to unlock this material.",
      notEligible: "Not eligible to start yet",
      joinedDay: "Joined at Day",
      noDays: "No published days yet.",
      noJourney: "No education journey for you yet. Activate your membership first.",
      completeDay: "Complete This Day",
      dayCompleted: "Day completed. The next day is unlocked.",
      saved: "Progress saved",
      markVideoWatched: "I have watched the video",
      markMaterialRead: "I have read the material",
      openPdf: "Open PDF document",
      reflectionPlaceholder: "Write your reflection (at least 10 characters)...",
      learnerView: "Member View",
      coachTab: "Coach Programme (9 days)",
      coachTabHint: "The 9-day coach programme unlocks day by day from the date you became a Coach.",
      memberTab: "Member Programme (preview)",
      noCoachJourney: "The 9-day coach programme is not available yet.",
      cms: "Manage Content",
      newJourney: "New Journey",
      newDay: "New Day",
      journeyCreated: "Journey created",
      reordered: "Day order updated",
      duplicated: "Day duplicated",
      contentItems: "content items",
      addItem: "Add Item",
      type_VIDEO: "Video",
      type_TEXT: "Written Material",
      type_IMAGE: "Image",
      type_PDF: "PDF",
      type_CHECKLIST: "Checklist",
      type_QUIZ: "Quiz",
      type_REFLECTION: "Reflection",
    },
    users: {
      eyebrow: "Master Admin",
      title: "User Management",
      subtitle: "Suspend, activate, change roles and manage account permissions",
      search: "Search",
      empty: "No matching users.",
      activate: "Activate",
      suspend: "Suspend",
      deactivate: "Deactivate",
      sendReset: "Send Reset",
      resendInvite: "Resend Invitation",
      permissions: "Permissions",
      permissionsHint: "Extra permissions granted specifically to this Co-Admin account.",
      delete: "Delete",
      deleteTitle: "Permanently delete this user",
      deleteWarning: "Everything they own is removed: journal posts, comments, reactions, points, measurements, education progress, payments, enrolments, notifications and every uploaded photo. Audit trails are kept without the identity. This cannot be undone.",
      deleteConfirmLabel: "Retype the user's email to confirm: {email}",
      deleteConfirmBtn: "Delete permanently",
      deleted: "User deleted along with {count} related records",
      statusChanged: "Account status updated",
      roleChanged: "Account role updated",
      resetSent: "Reset link sent",
      inviteResent: "Invitation resent",
      lastLogin: "Last login",
      extraPerms: "extra permissions",
      startDate: "Start",
      expirationDate: "Expiration",
      daysRemaining: "days left",
      editExpiration: "Edit Expiration",
      newExpiration: "New expiration date",
      reason: "Reason",
      reasonPlaceholder: "e.g. enrollment extension",
      expirationSaved: "Expiration updated",
    },
    landing: {
      eyebrow: "Coach-guided Fat Loss Program",
      heroTitle: "Lose fat with a Coach beside you, not just good intentions",
      heroBody: "A structured program with daily education material, a dedicated Coach and a fully transparent service fee. Register as a Member and join the next batch.",
      howTitle: "How It Works",
      step1Title: "Register as a Member",
      step1Body: "Fill in your details, pick a program and tell us your Coach preference. Verify your email to activate the account.",
      step2Title: "Pay the Support Service Fee",
      step2Body: "Transfer the exact unique amount, then upload the transfer proof straight from your phone.",
      step3Title: "Verification & Activation",
      step3Body: "Finance verifies the payment, then the Master Admin activates your membership.",
      step4Title: "Run the Program",
      step4Body: "Education material unlocks day by day while your Coach tracks your progress.",
      feeTitle: "Transparent Fee",
      feeBody: "The Support Service Fee is a Rp50,000 base plus your participant sequence as a unique code. That unique code makes every transfer easy to verify without mix-ups.",
      feePoint1: "No hidden charges",
      feePoint2: "The amount is computed by the system",
      feePoint3: "Transfer proof uploaded straight from your phone",
      programsTitle: "Open Programs & Batches",
      noOpenBatch: "No open batch at the moment.",
      seatsLeft: "seats left",
      coachTitle: "The Coach Role",
      galleryTitle: "Transformation Gallery",
      galleryBody: "Our five best results, measured at Final Day 15: before-and-after photos with the actual numbers.",
      galleryConsentNote: "Every photo is shown with the participant's consent, using shortened names.",
      coachBody: "Every Member is guided by a Coach. Members who have completed the program can take the Coach Qualification and, once approved by an Administrator, guide new Members.",
      faqTitle: "Frequently Asked",
      faq1Q: "How much do I transfer in total?",
      faq1A: "Rp50,000 plus your participant sequence. The exact amount appears on your payment page once your account is active.",
      faq2Q: "Can I register directly as a Coach?",
      faq2A: "No. Coach accounts are created by an Administrator or earned through the Coach Qualification program for Members.",
      faq3Q: "Can I choose my Coach?",
      faq3A: "You can state a preference during registration. The final assignment is decided by the Administrator based on availability.",
      faq4Q: "When does the education material unlock?",
      faq4A: "Daily material unlocks progressively — Day 1, Day 2 and onwards — based on your batch start date.",
      ctaTitle: "Ready to start your transformation?",
      ctaBody: "Register today, join the next batch and get Coach guidance throughout the program.",
    },
    education: {
      eyebrow: "Education",
      title: "Education Modules",
      subtitle: "Weekly material unlocked progressively by batch schedule",
      preview: "Learner View",
      newModule: "New Module",
      week: "Week",
      moduleTitle: "Module Title",
      summary: "Short summary",
      content: "Content",
      contentHint: "Write the educational material here…",
      videoUrl: "YouTube video link (optional)",
      isQualification: "Coach Qualification module",
      isQualificationHint: "This module is hidden from Members' weekly material and used only for Coach candidates. Qualification progress is computed from these modules.",
      quizQuestion: "Quiz question",
      quizOption: "Option",
      addQuestion: "Add Question",
      publish: "Publish",
      unpublish: "Unpublish",
      confirmDelete: "Delete this module?",
      noModules: "No modules for this program yet.",
      noModulesYet: "No material available yet.",
      noJourney: "No active batch yet. Material appears once your payment is approved.",
      thisWeek: "This week",
      unlocksOn: "Unlocks on",
      open: "Open",
    },
    admin: {
      revenue: "Revenue",
      approvedPayments: "approved payments",
      pendingPayments: "Awaiting Approval",
      members: "Members",
      pendingCandidates: "Coach Candidates",
      modulesPublished: "modules published",
      batchTable: "Participants per Batch",
      participants: "Participants",
      activeParticipants: "active participants",
      inQualification: "in qualification",
      activeMembers: "Active Members",
      activeCoaches: "Active Coaches",
      activeEnrollment: "Active Enrollment",
      expiredEnrollment: "Expired Enrollment",
      expiredEnrollmentSub: "needs re-enrollment",
      withEnrollment: "with enrollment",
      expiredShort: "expired",
      expiring7: "≤7 days",
      expiring14: "≤14 days",
    },
    progress: {
      title: "Daily Member Progress",
      members: "active members",
      behind: "behind",
      behindBadge: "Behind",
      allCoaches: "All Coaches",
      unassigned: "No Coach yet",
      empty: "No active members assigned yet.",
      lastDone: "Last completed",
      expected: "expected day",
      noJourney: "No education journey yet",
    },
    programs: {
      eyebrow: "Catalog",
      title: "Programs & Batches",
      subtitle: "Manage fat loss programs and their batches",
      newProgram: "New Program",
      editProgram: "Edit Program",
      name: "Program Name",
      calendarDays: "calendar days",
      durationMismatch: "Batch dates do not align with the program duration",
      alignedEnd: "aligned end:",
      description: "Description",
      durationDays: "Duration (days)",
      days: "days",
      empty: "No programs yet.",
      confirmDelete: "Delete this program?",
      confirmDeleteBatch: "Delete this batch?",
      batches: "Batches",
      newBatch: "New Batch",
      noBatches: "No batches for this program yet.",
      batchName: "Batch Name",
      batchCode: "Batch Code",
      startDate: "Start Date",
      endDate: "End Date",
      capacity: "Capacity",
      feeAmount: "Support Service Fee (IDR)",
      coaches: "Coaches",
      noCoach: "Not assigned",
      pickCoach: "Pick a coach",
      assign: "Assign",
      coachAssigned: "Coach assigned",
    },
    payments: {
      eyebrow: "Finance",
      queueTitle: "Payment Queue",
      queueSubtitle: "Approve or reject Support Service Fee payments",
      queueEmpty: "No payments.",
      tabPENDING: "Pending",
      tabAPPROVED: "Approved",
      tabREJECTED: "Rejected",
      tabALL: "All",
      approve: "Approve",
      reject: "Reject",
      approved: "Payment approved",
      rejected: "Payment rejected",
      rejectReason: "Rejection reason",
      confirmReject: "Confirm Reject",
      viewProof: "View proof",
      source: "Source",
      payAndEnroll: "Pay & Enroll",
      payTitle: "Support Service Fee Payment",
      transferTo: "Transfer to",
      proofUrl: "Transfer proof link",
      note: "Note (optional)",
      submit: "Submit Payment",
      submitted: "Payment submitted, awaiting verification",
      manualCreate: "Manual Entry",
      memberEmail: "Member Email",
      amount: "Amount (IDR)",
      proofImage: "Transfer proof photo",
      tapToUpload: "Tap to take / choose a photo",
      uploading: "Uploading…",
      uploaded: "Photo uploaded",
      fileType: "Only JPG, PNG or WEBP",
      fileSize: "Max size 5 MB",
      optimizing: "Optimizing…",
      processError: "This photo couldn't be processed. Please try another one.",
      proofHint: "Auto-optimized before upload · JPG / PNG / WEBP",
      proofRequired: "Upload the transfer proof photo first",
      participantCode: "Participant Code",
      baseFee: "Support Service Fee",
      uniqueCode: "Unique Code",
      totalToPay: "Total Transfer",
      exactAmountHint: "Transfer the exact amount (including the unique code) so the payment can be verified.",
      mismatch: "Amount Mismatch",
      mismatchReason: "Mismatch note",
      confirmMismatch: "Flag Mismatch",
      mismatched: "Payment flagged as mismatch; member may resubmit",
      tabMISMATCH: "Mismatch",
      alreadyEnrolled: "You are already enrolled in this batch. See My Journey for status.",
      method_BANK_TRANSFER: "Bank Transfer",
      destination: "Destination account",
      copyAccount: "Copy Account No.",
      copyAmount: "Copy Amount",
      copiedAccount: "Account number copied",
      copiedAmount: "Amount copied",
      copyFailed: "Copy failed, please copy manually",
    },
    enrollments: {
      title: "Participants",
      empty: "No participants in this batch yet.",
      activate: "Activate",
      activated: "Enrollment activated",
      create: "Create Enrollment",
      created: "Enrollment created",
      manualHint: "Enroll a member manually. Participant Code and total transfer are computed by the server (Rp50,000 + sequence).",
    },
    coach: {
      eyebrow: "Coach Development",
      title: "Coach Candidates",
      tabIN_QUALIFICATION: "Qualifying",
      tabWAITING_REVIEW: "Waiting Review",
      tabAPPROVED: "Approved",
      tabREJECTED: "Rejected",
      tabALL: "All",
      progress: "Qualification progress",
      progressSaved: "Progress saved",
      proofTitle: "Herbalife Membership Proof",
      proofNone: "The candidate has not uploaded a membership proof yet.",
      proofStatus_PENDING: "Awaiting verification",
      proofStatus_APPROVED: "Proof approved",
      proofStatus_REJECTED: "Proof rejected",
      proofApprove: "Approve proof",
      proofReject: "Reject proof",
      proofApproved: "Proof approved",
      proofRejected: "Proof rejected — the candidate must re-upload",
      proofNote: "Note for the candidate (optional)",
      proofView: "View full size",
      saveProgress: "Save",
      markComplete: "Mark 100%",
      qualifyingInfo: "You are in the Coach qualification process. Your role stays Member until approved.",
      subtitle: "Review candidates and grant the Coach role",
      empty: "No candidates.",
      addCandidate: "Add Candidate",
      added: "Candidate added",
      note: "Note",
      review: "Review",
      approve: "Approve & Make Coach",
      approvedMsg: "Candidate approved, Coach role granted",
      rejectedMsg: "Candidate rejected",
      activeEnrollments: "Active enrollments",
      becomeCoach: "Become a Coach",
      applyInfo: "Completed a program? Apply to become a Coach. The Coach Development team will review your application.",
      motivation: "Your motivation",
      proof: "Herbalife membership proof",
      proofHint: "Upload a screenshot of your official Herbalife membership or official invoice as an M100 member (JPG/PNG/HEIC, max 10MB).",
      proofRequired: "Upload your official Herbalife membership proof or invoice first.",
      programAfterApproval: "The 9-day coach programme opens under Education once your application is approved.",
      apply: "Apply",
      applied: "Application submitted",
      pendingInfo: "Your application is under review.",
    },
    journey: {
      eyebrow: "Member",
      title: "My Journey",
      subtitle: "Your enrollments, payments and Participant Code",
      browse: "Browse Programs",
      enrollments: "Enrollments",
      noEnrollments: "No enrollments yet. Pick a batch on the Programs page.",
      payments: "Payment History",
      myMembers: "My Members",
      noMembers: "No members assigned to you yet.",
      noPayments: "No payments yet.",
    },
    validation: {
      required: "Required",
      emailInvalid: "Invalid email format",
      passwordWeak: "Password must be at least 8 chars with upper, lower and a digit",
      passwordMismatch: "Passwords do not match",
      whatsappInvalid: "Invalid WhatsApp number format",
    },
    auth: {
      loginTitle: "Login to Fat Loss Program",
      loginSubtitle: "One account for Members, Coaches and Administrators",
      coachInfoTitle: "Coach",
      coachInfoBody: "Already have a Coach account? Login using the account provided by the Administrator.",
      registerTitle: "Register as a Member",
      registerSubtitle: "Start your fat loss program today",
      stepAccount: "Account",
      stepProfile: "Profile",
      stepProgram: "Program",
      stepReview: "Review",
      regNext: "Next",
      regProgram: "Program",
      regProgramNone: "Decide later",
      regCoach: "Coach Preference",
      regCoachAny: "No preference / Assigned by Admin",
      regCoachHint: "Your preference is considered; the final assignment is decided by the Administrator.",
      regWhatsappHint: "Optional. Used for program communication.",
      inviteCoach: "Create Coach Account",
      inviteSend: "Send Invitation",
      inviteSent: "Coach invitation sent",
      inviteHint: "The system creates an account with the Coach role and emails an invitation link. The Coach sets their own password — no password is ever emailed.",
      inviteAcceptTitle: "Activate Coach Account",
      inviteAcceptSubtitle: "Set your password to activate the account.",
      inviteSetPassword: "Set Password",
      inviteAccepted: "Account active. Please log in.",
      suspended: "Your account is suspended. Please contact the Administrator.",
      deactivated: "Your account is deactivated. Please contact the Administrator.",
      tokenInvalid: "This link is invalid or already used.",
      tokenExpired: "This link has expired.",
      loginSubmit: "Login",
      rememberMe: "Stay signed in on this device",
      showPassword: "Show password",
      hidePassword: "Hide password",
      registerSubmit: "Create Account",
      registerSuccess: "Account created. A verification link was sent to your email.",
      forgotTitle: "Forgot Password?",
      forgotSubtitle: "Enter your email and we'll send you a reset link.",
      forgotSubmit: "Send Reset Link",
      forgotSent: "If your email is registered, a reset link was sent.",
      previewLabel: "Link preview (test accounts)",
      resetTitle: "Reset Password",
      resetSubtitle: "Choose a new password for your account.",
      newPassword: "New Password",
      resetSubmit: "Reset Password",
      resetSuccess: "Password reset successfully. Please log in.",
      verifyTitle: "Verify Email",
      verifying: "Verifying your email…",
      verifySuccess: "Email verified. You may log in now.",
      verifyFail: "Verification link is invalid or expired.",
      verifyRequired: "Email not verified",
      verifyPlease: "Please verify your email first.",
      resendVerification: "Resend verification email",
      resendSent: "If your email is registered, a verification email was sent.",
      alreadyAccount: "Already have an account?",
      noAccount: "No account yet?",
      forgotLink: "Forgot Password?",
      loginLink: "Login",
      registerLink: "Register as a Member",
      invalidCredentials: "Invalid email or password",
      emailTaken: "Email already registered",
      locked: "Too many failed attempts. Try again later.",
      rateLimited: "Too many requests. Try again later.",
    },
    dashboard: {
      welcome: "Welcome back",
      scope_member: "Member Dashboard",
      scope_coach: "Coach Dashboard",
      scope_admin: "Command Center",
      hint_member: "Manage your enrollment, Support Service Fee payment and Participant Code.",
      hint_coach: "Track the members assigned to you and their education material.",
      hint_admin: "Metrics, payment verification and program management based on your permissions.",
      role: "Role",
      status: "Status",
      preview: "Programs, Batches, Payments and Coach Candidates are live. Education & Food Journal arrive in later phases.",
      profile: "Profile",
      viewProfile: "View Profile",
    },
    profile: {
      title: "My Profile",
      subtitle: "Update your profile information",
      preferences: "Preferences",
      saved: "Changes saved",
      viewPreference: "View Preference",
      auto: "Auto",
      mobile: "Mobile",
      desktop: "Desktop",
    },
    roles: {
      MASTER_ADMIN: "Master Admin",
      CO_ADMIN: "Co-Admin",
      COACH: "Coach",
      MEMBER: "Member",
    },
  },
};

export const ERROR_CODE_MAP = {
  AUTH_INVALID_CREDENTIALS: "invalidCredentials",
  AUTH_EMAIL_TAKEN: "emailTaken",
  AUTH_LOCKED: "locked",
  RATE_LIMITED: "rateLimited",
  AUTH_EMAIL_NOT_VERIFIED: "verifyPlease",
  AUTH_ACCOUNT_SUSPENDED: "suspended",
  AUTH_ACCOUNT_DEACTIVATED: "deactivated",
  AUTH_INVALID_TOKEN: "tokenInvalid",
  AUTH_TOKEN_EXPIRED: "tokenExpired",
};
